//
// HierarchySortContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./SortContext";

var HierarchySortContext = createModule("commons::HierarchySortContext", ["commons::SortContext"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getSortForLevel: [1,1],
        setSortForLevel: [0,1,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default HierarchySortContext;
